<template>
  <div class="container">
    <!-- 总支出卡片 -->
    <div class="total-expense-card">
      <div class="total-expense-bg"></div>
      <div class="total-expense-content">
        <div class="total-expense-label">本年度总支出（{{ currentYear }}年）</div>
        <div class="total-expense-value">{{ formatMoney(totalExpenseValue) }}</div>
      </div>
    </div>

    <!-- Tab切换 -->
    <div class="custom-tabs">
      <div
        class="custom-tab"
        :class="{ active: activeTab === 'property' }"
        @click="switchTab('property')"
      >
        <img :src="activeTab === 'property' ? require('../../assets/newicon/wyfwf_a.png') : require('../../assets/newicon/wyfwf.png')" alt="物业费" />
        <span class="tab-title">物业费</span>
        <span class="tab-amount">{{ formatMoneyShort(tabData.property.expense) }}</span>
      </div>
      <div
        class="custom-tab"
        :class="{ active: activeTab === 'public' }"
        @click="switchTab('public')"
      >
        <img :src="activeTab === 'public' ? require('../../assets/newicon/ggsy_a.png') : require('../../assets/newicon/ggsy.png')" alt="公共收益" />
        <span class="tab-title">公共收益</span>
        <span class="tab-amount">{{ formatMoneyShort(tabData.public.expense) }}</span>
      </div>
      <div
        class="custom-tab"
        :class="{ active: activeTab === 'agency' }"
        @click="switchTab('agency')"
      >
        <img :src="activeTab === 'agency' ? require('../../assets/newicon/dsfhs_a.png') : require('../../assets/newicon/dsfhs.png')" alt="代收代交费" />
        <span class="tab-title">代收代交费</span>
        <span class="tab-amount">{{ formatMoneyShort(tabData.agency.expense) }}</span>
      </div>
      <!-- <div
        class="custom-tab"
        :class="{ active: activeTab === 'parking' }"
        @click="switchTab('parking')"
      >
        <img :src="activeTab === 'parking' ? require('../../assets/newicon/rfcwzj_a.png') : require('../../assets/newicon/rfcwzj.png')" alt="人防车位租金" />
        <span class="tab-title">人防车位租金</span>
        <span class="tab-amount">{{ formatMoneyShort(tabData.parking.expense) }}</span>
      </div> -->
    </div>

    <!-- 筛选区域 -->
    <div class="filter-section">
      <div class="filter-row">
        <div class="filter-label-left">选择时间</div>
        <div class="filter-time-content">
          <div class="time-item" @click="showStartPicker = true">
            <span class="time-value">{{ startDate || '开始时间' }}</span>
            <img class="time-icon" src="../../assets/newicon/rl.png" alt="日历" />
          </div>
          <div class="time-divider">~</div>
          <div class="time-item" @click="showEndPicker = true">
            <span class="time-value">{{ endDate || '结束时间' }}</span>
            <img class="time-icon" src="../../assets/newicon/rl.png" alt="日历" />
          </div>
        </div>
      </div>
      <!-- 所有Tab都显示支出类型筛选 -->
      <template v-if="activeTab">
        <div class="filter-divider"></div>
        <div class="filter-row">
          <div class="filter-label-left">支出类型</div>
          <div class="filter-type-content" @click="showTypePicker = true">
            <span class="type-value">{{ expenseTypeName || '全部' }}</span>
            <van-icon name="arrow-down" size="14" color="#666" />
          </div>
        </div>
      </template>
    </div>

    <!-- 支出列表 -->
    <div class="expense-list">
      <div class="section-header">
        <h2 class="section-title">支出明细</h2>
        <span class="section-count">共{{ total }}条记录</span>
      </div>
      <van-loading v-if="loading" class="loading" />
      <div v-else-if="filteredList.length === 0" class="empty-state">
        <van-icon name="balance-pay" size="48" color="#999" />
        <div class="empty-text">暂无支出记录</div>
        <div class="empty-hint">请尝试调整筛选条件</div>
      </div>
      <div v-else>
        <div
          class="expense-card"
          v-for="item in filteredList"
          :key="item.id"
        >
          <div class="expense-info">
            <div class="expense-title">
              <span>{{ item.title }}</span>
              <span class="expense-amount">{{ formatMoney(item.amount) }}</span>
            </div>
            <div class="expense-meta">
              <div class="expense-meta-item">
                <span class="meta-label">所属小区：</span>
                <span class="meta-value">{{ item.community }}</span>
              </div>
              <div class="expense-meta-item">
                <span class="meta-label">支出类型：</span>
                <span class="meta-value">{{ item.typeName }}</span>
              </div>
              <div class="expense-meta-item">
                <span class="meta-label">支出所属时间：</span>
                <span class="meta-value">{{ item.date }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 日期选择器 -->
    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onStartConfirm"
        @cancel="showStartPicker = false"
      />
    </van-popup>
    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onEndConfirm"
        @cancel="showEndPicker = false"
      />
    </van-popup>

    <!-- 类型选择器 -->
    <van-popup v-model="showTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="typeColumns"
        @confirm="onTypeConfirm"
        @cancel="showTypePicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import axios from '@/utils/request'

export default {
  name: 'SzmxZc',
  data() {
    return {
      loading: false,
      activeTab: '',
      currentYear: new Date().getFullYear(),
      totalExpenseValue: 0,
      startDate: '',
      endDate: '',
      showStartPicker: false,
      showEndPicker: false,
      showTypePicker: false,
      expenseType: '',
      expenseTypeName: '全部',
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2030, 11, 31),
      // 各Tab数据
      tabData: {
        property: { expense: 0 },
        public: { expense: 0 },
        agency: { expense: 0 },
        parking: { expense: 0 }
      },
      // 支出类型配置（从接口获取）
      typeOptions: [],
      // 当前选中的子类型
      subType: '',
      // 支出明细列表
      expenseList: [],
      // 分页信息
      pageNum: 0,
      pageSize: 100,
      total: 0
    }
  },
  computed: {
    filteredList() {
      return this.expenseList
    },
    typeColumns() {
      // 根据当前Tab获取对应的支出类型选项
      const typeCode = this.getTypeCodeByTab()
      if (typeCode && this.typeOptions.length > 0) {
        const typeOption = this.typeOptions.find(t => t.typeCode === typeCode)
        if (typeOption && typeOption.subTypes) {
          // 添加"全部"选项
          const subTypes = [{ subTypeCode: '', subTypeName: '全部' }, ...typeOption.subTypes]
          return subTypes.map(item => item.subTypeName)
        }
      }
      return []
    },
    // 当前Tab对应的子类型列表
    currentSubTypes() {
      const typeCode = this.getTypeCodeByTab()
      if (typeCode && this.typeOptions.length > 0) {
        const typeOption = this.typeOptions.find(t => t.typeCode === typeCode)
        if (typeOption && typeOption.subTypes) {
          return [{ subTypeCode: '', subTypeName: '全部' }, ...typeOption.subTypes]
        }
      }
      return [{ subTypeCode: '', subTypeName: '全部' }]
    },
  },
  mounted() {
    this.initPage()
  },
  methods: {
    async initPage() {
      this.startDate = `${this.currentYear}-01-01`
      this.endDate = `${this.currentYear}-12-31`
      await Promise.all([
        this.loadSummary(),
        this.loadTypes(),
        this.loadList()
      ])

      // 固定本年度总支出，不随日期筛选变化
      this.totalExpenseValue = this.tabData.property.expense + this.tabData.public.expense + this.tabData.agency.expense + this.tabData.parking.expense
      this.loading = false
    },
    // 加载支出汇总（tab金额随日期变化）
    async loadSummary() {
      try {
        const params = {}
        if (this.startDate) params.startDate = this.startDate
        if (this.endDate) params.endDate = this.endDate
        if (!this.startDate && !this.endDate) {
          params.year = this.currentYear
        }
        const res = await axios.get('/api/v1/wyfzc/summary', { params })
        if (res) {
          this.tabData.property.expense = res.wyfExpense || 0
          this.tabData.public.expense = res.ggsyExpense || 0
          this.tabData.agency.expense = res.dsdjExpense || 0
        }
      } catch (error) {
        console.error('加载支出汇总失败:', error)
      }
    },
    // 加载支出类型列表
    async loadTypes() {
      try {
        const res = await axios.get('/api/v1/wyfzc/types')
        console.log('=== /api/v1/wyfzc/types 接口返回 ===')
        console.log(JSON.stringify(res, null, 2))
        if (res && Array.isArray(res)) {
          this.typeOptions = res
        }
      } catch (error) {
        console.error('加载支出类型失败:', error)
      }
    },
    // 获取当前Tab对应的支出类型（空表示全部）
    getExpenseTypeByTab() {
      if (!this.activeTab) return ''  // 没选择tab时返回空，表示查询全部
      const typeMap = {
        'property': '1',  // 物业服务费
        'public': '2',     // 公共收益
        'agency': '3',     // 代收代缴
        'parking': '4'      // 人防车位租金
      }
      return typeMap[this.activeTab] || ''
    },
    // 获取当前Tab对应的typeCode
    getTypeCodeByTab() {
      if (!this.activeTab) return ''
      const typeMap = {
        'property': '1',
        'public': '2',
        'agency': '3',
        'parking': '4'
      }
      return typeMap[this.activeTab] || ''
    },
    // 加载支出明细列表
    async loadList() {
      // 人防车位租金暂无数据，显示空列表
      if (this.activeTab === 'parking') {
        this.expenseList = []
        this.total = 0
        return
      }
      try {
        const params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
        if (this.startDate) params.startDate = this.startDate
        if (this.endDate) params.endDate = this.endDate
        // 根据当前Tab传递支出类型
        const expenseType = this.getExpenseTypeByTab()
        if (expenseType) params.expenseType = expenseType
        // 传递子类型参数
        if (this.subType) params.subType = this.subType

        const res = await axios.get('/api/v1/wyfzc/list', { params })
        if (res && res.data) {
          this.expenseList = res.data.map(item => ({
            id: item.id,
            title: item.title,
            amount: item.amount,
            type: item.expenseType,
            typeName: item.expenseTypeName,
            subType: item.subTypeCode,
            subTypeName: item.subTypeName,
            community: item.villageName,
            date: item.expenseDate,
            applyPurpose: item.applyPurpose,
            comment: item.comment
          }))
          this.total = res.total || 0
        }
      } catch (error) {
        console.error('加载支出明细失败:', error)
        this.expenseList = []
      }
    },
    switchTab(tab) {
      this.activeTab = tab
      // 切换Tab时重置支出类型筛选
      this.expenseType = ''
      this.expenseTypeName = '全部'
      if (!this.startDate) {
        this.startDate = `${this.currentYear}-01-01`
      }
      if (!this.endDate) {
        this.endDate = `${this.currentYear}-12-31`
      }
      this.loadList()
    },
    async onFilterChange() {
      this.loading = true
      await Promise.all([
        this.loadSummary(),
        this.loadList()
      ])
      this.loading = false
    },
    formatMoney(value) {
      if (!value && value !== 0) return '¥0'
      return '¥' + value.toLocaleString()
    },
    formatMoneyShort(value) {
      if (!value && value !== 0) return '0'
      if (value >= 10000) {
        return (value / 10000).toFixed(1) + '万'
      }
      return value.toLocaleString()
    },
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    onStartConfirm(value) {
      this.startDate = this.formatDate(value)
      this.showStartPicker = false
      this.onFilterChange()
    },
    onEndConfirm(value) {
      this.endDate = this.formatDate(value)
      this.showEndPicker = false
      this.onFilterChange()
    },
    onTypeConfirm(value, index) {
      this.expenseTypeName = value
      // 使用当前Tab对应的subTypes
      this.subType = this.currentSubTypes[index].subTypeCode
      this.showTypePicker = false
      this.onFilterChange()
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.total-expense-card {
  margin: 16px;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  height: 120px;
}

.total-expense-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('../../assets/newicon/sz.png');
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

.total-expense-content {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 20px 0 74px;
  color: white;
}

.total-expense-label {
  font-size: 15px;
  line-height: 23px;
  opacity: 0.9;
  margin-bottom: 8px;
}

.total-expense-value {
  font-size: 24px;
  font-weight: 700;
}

.custom-tabs {
  display: flex;
  padding: 0 16px;
  gap: 12px;
}

.custom-tab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  img {
    width: 23px;
    height: 23px;
    object-fit: contain;
  }

  span{
    font-size: 13px;
    color: #666;
    font-weight: 500;
  }

  .tab-title {
    font-size: 13px;
    font-weight: 500;
    // text-align: center;
    min-height: 34px;
    display: flex;
    align-items: center;
  }

  .tab-amount{
    font-size: 15px;
    font-weight: 700;
    color: #333;
  }

  &.active{
    background-color: #4892FB;
    box-shadow: 0 4px 12px rgba(72, 146, 251, 0.3);

    span{
      color: #fff;
    }

    .tab-amount{
      color: #fff;
    }
  }
}

.filter-section {
  background-color: #fff;
  border-radius: 12px;
  padding: 16px;
  margin: 12px 16px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.filter-row {
  display: flex;
  align-items: center;
  padding: 8px 0;
}

.filter-label-left {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  width: 70px;
  flex-shrink: 0;
}

.filter-time-content {
  flex: 1;
  display: flex;
  align-items: center;
}

.time-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.time-value {
  font-size: 14px;
  color: #333;
}

.time-icon {
  width: 14px;
  height: 14px;
}

.time-divider {
  padding: 0 8px;
  font-size: 14px;
  color: #666;
}

.filter-divider {
  height: 1px;
  background-color: #f0f0f0;
  margin: 8px 0;
}

.filter-type-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  gap: 4px;
}

.type-value {
  font-size: 14px;
  color: #333;
}

.expense-list {
  padding: 16px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.section-count {
  font-size: 12px;
  color: #7F7F7F;
}

.loading {
  text-align: center;
  padding: 32px 16px;
}

.empty-state {
  text-align: center;
  padding: 48px 16px;
  color: #999;
}

.empty-text {
  font-size: 16px;
  margin: 16px 0 8px;
}

.empty-hint {
  font-size: 14px;
}

.expense-card {
  background-color: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  padding: 16px;
}

.expense-info {
  width: 100%;
}

.expense-title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
  line-height: 1.3;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.expense-amount {
  font-size: 14px;
  font-weight: normal;
  color: #FF6B6B;
}

.expense-meta {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.expense-meta-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.meta-label {
  font-size: 13px;
  color: #999;
}

.meta-value {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}
</style>
